import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer } from '@splashthat/sui';

import { getFormLabel } from 'common/entities/form/selectors';
import { setFormLabel } from 'common/entities/form';

import { getFormId } from '../../selectors';
import { saveEditForm } from '../../actions';

import EditViewHeader from './EditViewHeader';
import EditViewSectionContainer from './EditViewSectionContainer';
import DraftTextEditorWrapper from './components/DraftTextEditorWrapper';

import './EditFormPanel.styl';

const HEADER_LABEL = 'Headline';
const TEXT_LABEL = 'Text';
const INPUT_PLACEHOLDER = 'This will appear on your form.';

const BASE_CLASS_NAME = 'EditFormHeadlinePanel';

/**
 * Edit view for changing the form entity (like form headline)
 */
class EditFormHeadlinePanel extends Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        formId: PropTypes.string.isRequired,
        saveEditForm: PropTypes.func.isRequired,
        setFormLabel: PropTypes.func.isRequired,
    };

    handleChangeLabel = (event, label, labelMarkup) => {
        this.props.setFormLabel(this.props.formId, labelMarkup);
    };

    render() {
        const { label } = this.props;
        return (
            <SuiContainer variation="flex-vertical" className={BASE_CLASS_NAME}>
                <EditViewHeader label={HEADER_LABEL} saveEditFormNode={this.props.saveEditForm} locked={false} />
                <SuiContainer className={`${BASE_CLASS_NAME}__content-container`}>
                    <EditViewSectionContainer>
                        <SuiContainer variation="flex-group">
                            <DraftTextEditorWrapper
                                fullWidth
                                label={TEXT_LABEL}
                                value={label}
                                placeholder={INPUT_PLACEHOLDER}
                                onChangeLabel={this.handleChangeLabel}
                                maxByteLimit={255}
                                enableCharacterCountdown
                            />
                        </SuiContainer>
                    </EditViewSectionContainer>
                </SuiContainer>
            </SuiContainer>
        );
    }
}

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const label = getFormLabel(state, formId);

    return {
        formId,
        label,
    };
};
const mapDispatchToProps = {
    saveEditForm,
    setFormLabel,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditFormHeadlinePanel);
